export default "__VITE_ASSET__C_D7zEwV__"